<div class="tw-text-center tw-p-12">
  <div [class]="'tw-w-fit tw-p-7 tw-mx-auto tw-mb-8 tw-rounded-full '+displayTranslateData.bgColor">
	  <i [class]="'tw-block tw-w-12 tw-h-12 tw-text-5xl '+displayTranslateData.iconClass" aria-hidden="true"></i>
  </div>
  <h3 class="tw-font-bold tw-w-fit tw-mx-auto tw-mb-3">{{ displayTranslateData.modalTitle | translate }}</h3>
  <p class="tw-w-fit tw-mx-auto" [innerHTML]="displayTranslateData.modalSubTitle | translate: { amount: amount, method: (method | translate), balance: balance }"></p>
  <button class="h3 tw-mt-4 tw-mb-0 tw-text-white tw-font-bold tw-w-full btn btn-primary" (click)="close()">{{ displayTranslateData.buttonText | translate }}</button>
</div>
